import { useContext, useMemo } from 'react';
import { useTimezoneDate } from '../useTimezoneDate';
import { CalendarContext } from '../../contexts/CalendarContext';
import { useMonth } from '../useMonth';

export const useActiveMonth = (offset: number = 0) => {
    const { activeDate, timezone } = useContext(CalendarContext);
    const { month, year, timezoneOffset } = useTimezoneDate(activeDate, timezone);
    const offsetActiveDate = useMemo(() => {
        const localMonth = new Date(year, month + offset - 1, 1, 0, 0, 0, 0);
        return new Date(localMonth.getTime() + timezoneOffset);
    }, [offset, year, month, timezoneOffset]);

    const offsetMonth = useMonth(offsetActiveDate);
    return offsetMonth;
};
